import hljs from 'highlight.js/lib/core';
import php from 'highlight.js/lib/languages/php';
import sql from 'highlight.js/lib/languages/sql';

hljs.registerLanguage('sql', sql);
hljs.registerLanguage('php', php);


document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-highlight-code] pre code').forEach(el => {
        el.parentElement.classList.add('styled-codeblock');
        el.classList.add('php');
        hljs.highlightBlock(el);
    });

    document.querySelectorAll('[data-highlight-code] code').forEach(el => {
        if ('PRE' === el.parentElement.tagName || !isBlockCode(el.innerHTML)) {
            return;
        }

        el.classList.add('php');

        let wrapper = document.createElement('pre');
        wrapper.classList.add('styled-codeblock');

        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);

        hljs.highlightBlock(el);
    });

    document.querySelectorAll('.wp-block-code code').forEach(el => {
        let language = 'php';
        if (el.parentElement.classList.contains('--sql')) {
            language = 'sql';
        }

        el.classList.add(language);

        el.parentElement.classList.add('styled-codeblock');
        hljs.highlightBlock(el);
    })

});

const isBlockCode = (code: string) => {
    return code.indexOf('<br') > 0 || code.length > 100;
}